<!--  -->
<template>
  <div>
    <div class="select_box">
      <div>
        <el-date-picker
          v-model="query.trade_create_date"
          class="item_search"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        />

        <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button type="info" icon="el-icon-refresh-right" @click="reast">重置</el-button>
      </div>
    </div>
    <el-table
      v-loading="loading"
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="platform_order_id"
        label="平台订单号"
        width="180"
        align="center"
      />
      <el-table-column
        prop="open_id"
        label="open_id"
        width="150"
        align="center"
      />
      <el-table-column
        prop="app_id"
        label="app_id"
        width="160"
        align="center"
      />
      <el-table-column
        prop="account_name"
        label="公众号名称"
        width="110"
        align="center"
      />
      <el-table-column
        prop="amount"
        label="金额(元)"
        width="80"
        align="center"
      />
      <el-table-column
        prop="transaction_id"
        label="交易id"
        width="150"
        align="center"
      />
      <el-table-column
        prop="trade_type_text"
        label="交易类型"
        width="100"
        align="center"
      />
      <el-table-column
        prop="trade_status"
        label="交易状态"
        width="100"
        align="center"
      />
      <el-table-column
        prop="trade_create_date"
        label="交易创建日期时间"
        width="160"
        align="center"
      />
      <el-table-column
        prop="trade_finish_date"
        label="交易完成日期时间"
        align="center"
      />
    </el-table>
    <pagination-right
      :current-page="query.page"
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import { userOrders } from '@/api/providerAccountManagement/WeChatAccountFans.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: { PaginationRight },
  data() {
    return {
      tableData: [],
      total: null,
      query: {
        page: 1,
        pageSize: 10,
        open_id: null,
        trade_create_date: []
      },
      loading: false
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    send(id) {
      console.log('收到')
      this.query.open_id = null
      this.query.open_id = id
      this.menlist()
    },
    async menlist() {
      this.loading = true
      const data = await userOrders(this.query)
      this.tableData = data.data.list
      this.total = data.data.total
      this.loading = false
      console.log('data', data)
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.menlist()
    },
    fetchPageSize(e) {
      this.query.pageSize = e
      this.menlist()
    },
    search() {
      this.query.page = 1
      this.menlist()
    },
    reast() {
      this.query.page = 1
      this.query.trade_create_date = []
      this.menlist()
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.select_box{
  margin-bottom: 10px;
}
.item_search{
  width: 400px;
  margin-right: 10px;
}
</style>
